module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Cupboard-731a05af59881e55b808c692f5f408668098b5680475af254aac87f84578385f.svg";